import { render } from "./FilterContainerSegments.vue?vue&type=template&id=12401f04"
import script from "./FilterContainerSegments.vue?vue&type=script&lang=js"
export * from "./FilterContainerSegments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__